/* eslint-disable react/prop-types */
import { FC } from 'react';
import styled from 'styled-components';
import { Logo } from 'cosmos-components';

import heroBanner from 'src/assets/images/hero-banner-new.jpg';
import { Divider } from 'src/components';
import { DeviceType } from 'src/enums';
import { useWindowDimensions } from 'src/hooks/useWindowDimensions';
import { getScreenBreaks } from 'src/utils/htmlHelper';

export const Header: FC = () => {
    const { deviceType } = useWindowDimensions();

    return (
        <StyledHeader>
            <HeaderIcons id="header-icons" deviceType={deviceType}>
                <HeaderIconContainer>
                    <ColoredMAUILogo name="maui" deviceType={deviceType} />
                </HeaderIconContainer>
                <HeaderIconContainer>
                    <ApolloLogo name="coloredApollo" deviceType={deviceType} />
                </HeaderIconContainer>
                <HeaderIconContainer>
                    <ColoredBritzLogo
                        name="coloredBritzHorizontal"
                        deviceType={deviceType}
                    />
                </HeaderIconContainer>
                <HeaderIconContainer>
                    <ColoredMightyLogo name="coloredMighty" deviceType={deviceType} />
                </HeaderIconContainer>
                <HeaderIconContainer>
                    <ColoredCheapaLogo
                        name="coloredCheapa"
                        deviceType={deviceType}
                    />
                </HeaderIconContainer>
            </HeaderIcons>
            <StyledHeroBanner src={heroBanner} />
            <StyledDivider />
        </StyledHeader>
    );
};

export const HeaderIconContainer = styled.div``;
export const StyledHeader = styled.div`
    display: inline-block;
    margin: 0;
    width: 100%;
    margin-bottom: 0;
`;
export const StyledDivider = styled(Divider)`
    background-image: ${({ theme: { colors } }) =>
        `linear-gradient(to left, ${colors.yellow},  ${colors.orange}, ${colors.red})`};
    height: 0.7rem;
    border-top: none;
    display: inline-block;
    padding-right: calc(100% - 0.5px);
    position: relative;
    top: -0.3rem;
    @media (min-width: ${(props) => getScreenBreaks(props).screenLMin}) {
        height: 1rem;
    }
`;
export const HeaderIcons = styled.div<{ deviceType: DeviceType }>`
    display: flex;
    padding: 0rem;
    margin: ${({ deviceType }) =>
        deviceType === DeviceType.Mobile ? '0 1rem' : '0 3rem 0.5rem'};
    min-height: ${({ deviceType }) =>
        deviceType === DeviceType.Mobile ? '5rem' : '8rem'};
    border-top: 0.1rem solid ${({ theme: { colors } }) => colors.secondaryGrey};
    justify-content: ${({ deviceType }) =>
        deviceType === DeviceType.Mobile ? 'space-evenly' : 'flex-start'};
    align-items: center;
    gap: ${({ deviceType }) =>
        deviceType === DeviceType.Mobile ? '0' : '2rem'};

    @media (min-width: ${(props) =>
            getScreenBreaks(props).screenSMax}) and (max-width: ${(props) =>
            getScreenBreaks(props).screenMDMax}) {
        width: 60.8rem;
    }

    @media (min-width: ${(props) => getScreenBreaks(props).screenLMin}) {
        width: 72rem;
    }
`;

export const ColoredMAUILogo = styled(Logo)<{ deviceType: DeviceType }>`
    fill: ${({ theme: { colors } }) => colors.blue};
    width: ${({ deviceType }) =>
        deviceType === DeviceType.Mobile ? '4.5rem' : '8rem'};
    padding-right: ${({ deviceType }) =>
        deviceType === DeviceType.Mobile ? '1.22rem' : '0'};
`;
export const ColoredBritzLogo = styled(Logo)<{ deviceType: DeviceType }>`
    scale: 2.35;
    width: ${({ deviceType }) =>
        deviceType === DeviceType.Mobile ? '8rem' : '15rem'};
    padding-right: ${({ deviceType }) =>
        deviceType === DeviceType.Mobile ? '0.5rem' : '0'};
    vertical-align: ${({ deviceType }) =>
        deviceType === DeviceType.Mobile ? '-0.2rem' : '-1rem'};
    transform: ${({ deviceType }) =>
        deviceType === DeviceType.Mobile ? 'translate(0.3rem, 0.1rem)' : 'translate(0.3rem, 0.3rem)'};
`;
export const ColoredMightyLogo = styled(Logo)<{ deviceType: DeviceType }>`
    path:last-child {
        fill: ${({ theme: { colors } }) => colors.secondaryRed};
    }
    width: ${({ deviceType }) =>
        deviceType === DeviceType.Mobile ? '5.5rem' : '10rem'};
    padding-right: ${({ deviceType }) =>
        deviceType === DeviceType.Mobile ? '1.16rem' : '0'};
    vertical-align: ${({ deviceType }) =>
        deviceType === DeviceType.Mobile ? '-1.5rem' : '-4rem'};
`;

export const ApolloLogo = styled(Logo)<{ deviceType: DeviceType }>`
    width: ${({ deviceType }) =>
        deviceType === DeviceType.Mobile ? '6rem' : '11rem'};
    padding-right: ${({ deviceType }) =>
        deviceType === DeviceType.Mobile ? '1.16rem' : '0'};
    vertical-align: ${({ deviceType }) =>
        deviceType === DeviceType.Mobile ? '-1rem' : '-3rem'};
`;

const ColoredCheapaLogo = styled(Logo)<{ deviceType: DeviceType }>`
    width: ${({ deviceType }) =>
        deviceType === DeviceType.Mobile ? '7.5rem' : '15rem'};
    vertical-align: ${({ deviceType }) =>
        deviceType === DeviceType.Mobile ? '-1rem' : '-4rem'};
`;

export const StyledHeroBanner = styled.img`
    display: block;
    width: 100%;
    object-fit: cover;
    object-position: center;
    height: 11rem;

    @media (min-width: ${(props) =>
            getScreenBreaks(props).screenMDMin}) and (max-width: ${(props) =>
            getScreenBreaks(props).screenMDMax}) {
        height: 15rem;
    }

    @media (min-width: ${(props) => getScreenBreaks(props).screenLMin}) {
        height: 25rem;
    }
`;
